import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CurrentFilterState } from "../../models/interfaces";

interface FilterSyncState {
  currentState: CurrentFilterState | null;
  loaded: boolean;
  restored: boolean;
}

const initialState: FilterSyncState = {
  currentState: null,
  loaded: false,
  restored: false,
};

const savedFiltersSlice = createSlice({
  name: "savedFilters",
  initialState,
  reducers: {
    setCurrentFilterState: (state, action: PayloadAction<CurrentFilterState | null>) => {
      state.currentState = action.payload;
      state.loaded = true;
      state.restored = false;
    },
    markRestored: (state) => {
      state.restored = true;
    },
    clearCurrentFilterState: (state) => {
      state.currentState = null;
      state.restored = false;
    },
  },
});

export const {
  setCurrentFilterState,
  markRestored,
  clearCurrentFilterState,
} = savedFiltersSlice.actions;
export default savedFiltersSlice.reducer;
